import type { BookingCity } from './booking-city';

export const BOOKING_CITIES: readonly BookingCity[] = [
    { key: 'almaty', office: 'Almaty', nameKk: 'Алматы', nameRu: 'Алматы' },
    { key: 'astana', office: 'Astana', nameKk: 'Астана', nameRu: 'Астана' }
] as const;
